import { ApiServiceBase } from "./apiServiceBase";

export class PopUpService extends ApiServiceBase {
  private apiUrl = "/api/popup/1.0";

  finishPopUp(
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ) {
    return this.post(this.apiUrl + "/finished", onSuccess, onFailure);
  }

  showPopUpAgain(
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ) {
    return this.post(this.apiUrl + "/shown", onSuccess, onFailure);
  }

  getPopUpInfo(
    onSuccess: (response: any) => void,
    onFailure: (response: any) => void
  ) {
    return this.get(this.apiUrl + "/content", onSuccess, onFailure);
  }
}
